import { Vue, Component, Prop, Watch } from "vue-property-decorator";

@Component({
    name: "RightText"
})
export default class RightText extends Vue {
    @Prop() readonly text: string;
    @Prop() studentAvatar: string;
    mounted() {
        this.studentAvatar = this.studentAvatar
            ? this.studentAvatar
            : "https://asset.greedyai.com/sun/img/defaultAvatar.png";
    }
}

//@ts-ignore
export { default as RightText } from "./index.vue";
